import React, { useRef, useEffect } from 'react'
import { useDataChange } from 'Simple/Data.js'
import View from './view.js'
import './styles.css'

export default function Logic(props) {
  let scrollContainerRef = useRef(null)

  let change = useDataChange({
    context: 'arrows',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    let element = scrollContainerRef.current
    if (!element) return

    let check = () => {
      let scrollable = element.scrollWidth > element.clientWidth

      change(next => {
        next.isScrollable = scrollable
        next.isAtStart = scrollable && element.scrollLeft === 0
        next.isAtEnd =
          scrollable &&
          element.scrollLeft + element.clientWidth >= element.scrollWidth - 1
      })
    }

    // Check initially
    check()

    // Check on resize
    let resizeObserver = new ResizeObserver(check)
    resizeObserver.observe(element)

    // Check on scroll
    element.addEventListener('scroll', check)

    return () => {
      resizeObserver.disconnect()
      element.removeEventListener('scroll', check)
    }
  }, [props.payors])

  return <View {...props} scrollContainerRef={scrollContainerRef} />
}
